<div class="modal-header">
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" [attr.aria-label]="'button.close' | translate"></button>
</div>
<div class="modal-body">
  <p class="text-center">
    <span>{{ errorMessage.message | translate }}</span>
    <ng-container
      *ngIf="errorMessage.eMail && errorMessage.end"
    >
      <a
        class="e-mail-link"
        href="mailto:{{ errorMessage.eMail | translate }}"
        >{{ errorMessage.eMail | translate }}</a
      ><span>{{ errorMessage.end | translate }}</span>
    </ng-container>
  </p>

  <div class="d-flex justify-content-center align-items-center p-3">
    <i class="bi bi-exclamation-circle-fill fs-1"></i>
  </div>
</div>
